export const BOOL_DROPDOWN = [
    {label: 'IC', value: 'IC'},
    {label: '-', value: '-'}
]